import type {SweepPageContent} from '../../store/thread';
import {agentPageContextChannel, type AgentPageContextReader} from '../channel';

/** SweepFacts is the sweep's reported content, published as one value. */
type SweepFacts = Omit<SweepPageContent, 'type'>;

export const sweepFacts = agentPageContextChannel<SweepFacts>();

/** sweepReducer assembles the sweep page content from its one channel. */
export const sweepReducer = (
  read: AgentPageContextReader
): Omit<SweepPageContent, 'type'> => ({
  ...read.one(sweepFacts),
});
